/*

    controleren namezzzcountry & jobpreferences region

*/
import React, { Component } from 'react';
import { getJsonItem, getJsonItemInvariantCase } from '../Utilities/JsonFunctions.js';
import FormExplanationValidation from './FormExplanationValidation.js';

declare var $;

class FormAutocomplete extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onBlur = this.onBlur.bind(this);
        
        this.state = {
            data: this.props.data
        }
    }

    onChange(e, data) {
        this.props.onChange(e, data);
    }

    onKeyPress(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            
            if (this.props.onEnter == null) {
                return;
            }
            this.props.onEnter(e);
        }
    }

    onBlur(e) {
        if (this.props.onBlur == null) {
            return;
        }
        this.props.onBlur(e);
    }

    componentDidMount() {
        this.setAutoComplete(true);   
    }

    setAutoComplete(initial) {
        var _this = this;

        this.$el = $(this.el);
        if (initial) {
            this.$el.val(this.getItemTextById(this.props.value));
        }
        this.$el.autocomplete({
            source: [
                this.props.data
            ],
            valueKey: 'value',
            titleKey: 'value',
            showHint: false,
            autoselect: true,
            visibleLimit: 10,
            limit: 10000
        }).on("autocompleted.xdsoft", function(e, data) {
            _this.onChange(e, data.key);
        }).on('blur', function(e) {
            var item = getJsonItemInvariantCase(_this.props.data, "value", e.target.value);
            if (item != null)
                _this.onChange(e, item.key)
        }).on('keydown', function(e) {
            if (e.keyCode === 27) {
                if (_this.props.onEscape != null) {
                    _this.props.onEscape(e);
                }
            }
            
        });

        if (_this.props.onEscape != null) {
            document.addEventListener("keydown", this.onKeyPress, false);
        }
    }

    componentWillUnmount() {
        this.$el.autocomplete('destroy');

        if (this.props.onEscape != null) {
            document.removeEventListener("keydown", this.onKeyPress, false);
        }
    }

    componentDidUpdate() {
        var text = this.getItemTextById(this.props.value);        
        if (text != null) {
            this.$el.val(text);
        }

        if (this.state.data !== this.props.data) {
            this.setState({
                data: this.props.data
            });
            
            this.$el.autocomplete('destroy').removeClass('xdsoft_input');
            this.setAutoComplete(false);
        }        
    }

    getItemTextById(id) {
        var item = getJsonItem(this.props.data, "key", id);
        
        if (item == null) {
            return null;
        }

        return item.value;
    }

    render() {
        let requiredMark = this.props.required ? <span className="required-mark">*</span> : null;

        return (
            <div className="EditingFormValueCell td">
                <input type="text" id={this.props.id} ref={el => this.el = el} maxLength="200" className="form-control" readOnly={this.props.readonly}
                    onChange={this.onChange} onKeyPress={this.onKeyPress} onBlur={this.onBlur} />
                {requiredMark}                    
                <FormExplanationValidation id={this.props.id} explanation={this.props.explanation} showValidation={this.props.showValidation} validationText={this.props.validationText} />
            </div>
        );
    }
}

export default FormAutocomplete;


// WEBPACK FOOTER //
// ./src/Fields/FormAutocomplete.js